var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshZoomWhiteBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#fff",
    stroke: "#e8eaee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "refresh_20dp_5F6368_FILL0_wght400_GRAD0_opsz20_1_",
    "data-name": "refresh_20dp_5F6368_FILL0_wght400_GRAD0_opsz20 (1)",
    d: "M201.1-749.81a8.771,8.771,0,0,1-6.442-2.653A8.771,8.771,0,0,1,192-758.9a8.771,8.771,0,0,1,2.653-6.442A8.771,8.771,0,0,1,201.1-768a8.582,8.582,0,0,1,3.805.853,9.623,9.623,0,0,1,3.016,2.274v-1.99a1.1,1.1,0,0,1,.325-.81,1.09,1.09,0,0,1,.805-.327,1.113,1.113,0,0,1,.812.327,1.092,1.092,0,0,1,.332.81v5.306a1.1,1.1,0,0,1-.327.81,1.1,1.1,0,0,1-.81.327h-5.306a1.1,1.1,0,0,1-.81-.325,1.09,1.09,0,0,1-.327-.805,1.112,1.112,0,0,1,.327-.812,1.092,1.092,0,0,1,.81-.332h3a6.727,6.727,0,0,0-2.4-2.211,6.607,6.607,0,0,0-3.253-.821,6.578,6.578,0,0,0-4.832,1.99,6.578,6.578,0,0,0-1.99,4.832,6.578,6.578,0,0,0,1.99,4.832,6.578,6.578,0,0,0,4.832,1.99,6.49,6.49,0,0,0,4.169-1.437,6.682,6.682,0,0,0,2.369-3.616,1.189,1.189,0,0,1,.521-.695,1.2,1.2,0,0,1,.838-.189,1.11,1.11,0,0,1,.757.426.933.933,0,0,1,.189.805,8.978,8.978,0,0,1-3.158,5.006A8.75,8.75,0,0,1,201.1-749.81Z",
    transform: "translate(-189.095 770.905)",
    fill: "#2e4d7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshZoomWhiteBackground);
export default __webpack_public_path__ + "static/media/RefreshZoomWhiteBackground.f83d23b01a8c4a14402cc6cfa55c7f3e.svg";
export { ForwardRef as ReactComponent };